var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatFileSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.695 0.2407C14.0712 0.589171 14.1039 1.18805 13.768 1.57834L5.07238 11.6836C4.89915 11.8849 4.6514 12 4.3913 12C4.13121 12 3.88346 11.8849 3.71023 11.6836L0.231979 7.64149C-0.103866 7.25121 -0.0711952 6.65232 0.304951 6.30385C0.681097 5.95538 1.25828 5.98928 1.59412 6.37957L4.39131 9.63019L12.4059 0.316415C12.7417 -0.0738718 13.3189 -0.107771 13.695 0.2407Z",
    fill: "#2DBB6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFileSuccessIcon);
export default __webpack_public_path__ + "static/media/chatFileSuccessIcon.0aa1b5f9.svg";
export { ForwardRef as ReactComponent };